function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M243 16H239V56H243V16Z",
  fill: "#EEEEEE"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M259 16H255V56H259V16Z",
  fill: "#EEEEEE"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M251 16H247V56H251V16Z",
  fill: "#EEEEEE"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M267 16H263V56H267V16Z",
  fill: "#EEEEEE"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M275 16H271V56H275V16Z",
  fill: "#EEEEEE"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M275 8H239V16H275V8Z",
  fill: "#EEEEEE"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M159 16H151V56H159V16Z",
  fill: "#F8F8F8"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M111 16H103V56H111V16Z",
  fill: "#F8F8F8"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M175 16H167V56H175V16Z",
  fill: "#F8F8F8"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M191 16H183V56H191V16Z",
  fill: "#F8F8F8"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M215 24H199V56H215V24Z",
  fill: "#E2E2E2"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M223 16H215V56H223V16Z",
  fill: "#F8F8F8"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M239 16H231V56H239V16Z",
  fill: "#F8F8F8"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M247 16H243V56H247V16Z",
  fill: "black",
  fillOpacity: 0.1
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M263 16H259V56H263V16Z",
  fill: "black",
  fillOpacity: 0.1
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M255 16H251V56H255V16Z",
  fill: "black",
  fillOpacity: 0.1
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M271 16H267V56H271V16Z",
  fill: "black",
  fillOpacity: 0.1
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M159 16H167V56H159V16Z",
  fill: "#EEEEEE"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M111 16H115V56H111V16Z",
  fill: "#EEEEEE"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M223 16H231V56H223V16Z",
  fill: "#EEEEEE"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M175 16H183V56H175V16Z",
  fill: "#EEEEEE"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M191 16H199V56H191V16Z",
  fill: "#EEEEEE"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M215 16H199V24H215V16Z",
  fill: "#EEEEEE"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M300 32.5C300 46.5833 293.06 51 284.5 51C275.94 51 269 46.5833 269 32.5C269 18.4167 284.5 0 284.5 0C284.5 0 300 18.4167 300 32.5Z",
  fill: "#F8F8F8"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M31 32.5C31 46.5833 24.0604 51 15.5 51C6.93959 51 0 46.5833 0 32.5C0 18.4167 15.5 0 15.5 0C15.5 0 31 18.4167 31 32.5Z",
  fill: "#F8F8F8"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M285.396 50.9833C291.032 48.7893 295 42.7633 295 30.2352C295 20.1056 289.206 8.07034 284.703 0.24585C286.527 2.47253 300 19.3696 300 32.4999C300 46.0882 293.54 50.6775 285.396 50.9833Z",
  fill: "black",
  fillOpacity: 0.03
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.3964 50.9833C22.0323 48.7893 26 42.7633 26 30.2352C26 20.1056 20.2064 8.07034 15.7033 0.24585C17.5268 2.47253 31 19.3696 31 32.4999C31 46.0882 24.5397 50.6775 16.3964 50.9833Z",
  fill: "black",
  fillOpacity: 0.03
});

var _ref29 = /*#__PURE__*/React.createElement("line", {
  x1: 285,
  y1: 51,
  x2: 285,
  y2: 56,
  stroke: "#F7F7F7",
  strokeWidth: 2
});

var _ref30 = /*#__PURE__*/React.createElement("line", {
  x1: 16,
  y1: 51,
  x2: 16,
  y2: 56,
  stroke: "#F7F7F7",
  strokeWidth: 2
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M366 32.5C366 46.5833 359.06 51 350.5 51C341.94 51 335 46.5833 335 32.5C335 18.4167 350.5 0 350.5 0C350.5 0 366 18.4167 366 32.5Z",
  fill: "#F8F8F8"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M351.396 50.9833C357.032 48.7893 361 42.7633 361 30.2352C361 20.1056 355.206 8.07034 350.703 0.24585C352.527 2.47253 366 19.3696 366 32.4999C366 46.0882 359.54 50.6775 351.396 50.9833Z",
  fill: "black",
  fillOpacity: 0.03
});

var _ref33 = /*#__PURE__*/React.createElement("line", {
  x1: 351,
  y1: 51,
  x2: 351,
  y2: 56,
  stroke: "#F7F7F7",
  strokeWidth: 2
});

var _ref34 = /*#__PURE__*/React.createElement("circle", {
  cx: 385,
  cy: 32,
  r: 16,
  fill: "#F8F8F8"
});

var _ref35 = /*#__PURE__*/React.createElement("circle", {
  cx: 55,
  cy: 32,
  r: 16,
  fill: "#F8F8F8"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M387.562 47.7959C392.651 44.3869 396 38.5846 396 32C396 25.4154 392.651 19.6132 387.562 16.2041C395.181 17.4304 401 24.0357 401 32C401 39.9644 395.181 46.5696 387.562 47.7959Z",
  fill: "black",
  fillOpacity: 0.03
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M57.5624 47.7959C62.6505 44.3869 66 38.5846 66 32C66 25.4154 62.6505 19.6132 57.5624 16.2041C65.1808 17.4304 71 24.0357 71 32C71 39.9644 65.1808 46.5696 57.5624 47.7959Z",
  fill: "black",
  fillOpacity: 0.03
});

var _ref38 = /*#__PURE__*/React.createElement("line", {
  x1: 386,
  y1: 48,
  x2: 386,
  y2: 56,
  stroke: "#F7F7F7",
  strokeWidth: 2
});

var _ref39 = /*#__PURE__*/React.createElement("line", {
  x1: 56,
  y1: 48,
  x2: 56,
  y2: 56,
  stroke: "#F7F7F7",
  strokeWidth: 2
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M202.045 35.6299C202.045 34.5 202.382 34 203.5 34C204 34 204.545 34.63 204.545 35.63C204.545 36.1517 204.312 36.4446 204.089 36.7248C203.885 36.9817 203.689 37.2279 203.689 37.63C203.689 38.4313 203.933 38.5191 204.314 38.6558C204.645 38.775 205.079 38.9313 205.545 39.63C205.99 40.2973 205.77 43.5846 205.495 47.6735C205.286 50.7948 205.045 54.3832 205.045 57.63C204.796 57.6656 204.566 57.6988 204.354 57.7294L204.348 57.7303C202.184 58.043 201.894 58.085 202.045 57.63L203.045 57.13L203.295 56.63C203.295 56.63 202.126 49.6374 201.456 44.6082C201.362 44.6919 201.262 44.773 201.157 44.8509C200.419 45.3989 199.462 45.7565 198.246 45.8139L198.246 45.8212C198.206 45.8206 198.166 45.8197 198.127 45.8185C198.088 45.8197 198.05 45.8206 198.011 45.8211L198.011 45.8142C196.813 45.7611 195.876 45.442 195.157 44.943C194.883 44.7529 194.648 44.5414 194.446 44.3174C193.802 49.3673 192.504 57.13 192.504 57.13L192.754 57.63L193.754 58.13C193.905 58.585 193.615 58.5431 191.451 58.2304L191.443 58.2291C191.232 58.1986 191.002 58.1654 190.754 58.13C190.754 54.8832 190.513 51.2948 190.304 48.1735C190.029 44.0846 189.809 40.7973 190.254 40.13C190.72 39.4313 191.154 39.275 191.486 39.1558C191.866 39.0191 192.11 38.9313 192.11 38.13C192.11 37.7279 191.914 37.4817 191.71 37.2248C191.487 36.9446 191.254 36.6517 191.254 36.13C191.254 35.13 191.799 34.5 192.299 34.5C193.417 34.5 193.754 35 193.754 36.1299C193.754 36.7575 193.429 37.0983 193.15 37.392C192.926 37.6272 192.731 37.8321 192.754 38.13C192.799 38.7196 193.248 38.9587 193.72 39.2102C194.13 39.4284 194.557 39.6559 194.754 40.13C194.814 40.2743 194.812 40.718 194.764 41.3736C194.801 41.7039 194.88 42.0911 195.037 42.4719C195.229 42.9348 195.532 43.3771 196.013 43.7108C196.47 44.0284 197.137 44.2815 198.126 44.3177C199.102 44.2803 199.78 44.0048 200.263 43.6466C200.675 43.3408 200.976 42.9505 201.197 42.5284C201.021 40.9845 200.944 39.8752 201.045 39.63C201.242 39.1559 201.669 38.9284 202.079 38.7102C202.551 38.4587 203 38.2196 203.045 37.63C203.068 37.3321 202.873 37.1272 202.649 36.892C202.37 36.5983 202.045 36.2575 202.045 35.6299Z",
  fill: "black"
});

var _ref41 = /*#__PURE__*/React.createElement("rect", {
  x: 151,
  y: 8,
  width: 88,
  height: 8,
  fill: "#F8F8F8"
});

var _ref42 = /*#__PURE__*/React.createElement("rect", {
  x: 103,
  y: 8,
  width: 48,
  height: 8,
  fill: "#F8F8F8"
});

var _ref43 = /*#__PURE__*/React.createElement("rect", {
  x: 229,
  width: 4,
  height: 8,
  fill: "#EEEEEE"
});

var _ref44 = /*#__PURE__*/React.createElement("rect", {
  x: 217,
  width: 12,
  height: 8,
  fill: "#F8F8F8"
});

function SvgPrerollBanner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 401,
    height: 59,
    viewBox: "0 0 401 59",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrerollBanner);
export default __webpack_public_path__ + "static/media/preroll-banner.86c9483f.svg";
export { ForwardRef as ReactComponent };